import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'components/shared/modal'
import { Link } from 'react-router-dom'

const BookingMembersModal = ({ list, fetching, bookingDate, numberOfBookings, space, spaceUrl, onClose, status }) => {
  const isActive = ['booked', 'confirmed'].includes(status)

  return (
    <Modal header={<div className='px-1 text-base lg:text-xl text-left lato-bold'>Booking Details</div>} onClose={onClose}>
      {!fetching && (
        <div className="modal-body">
          <table className='w-full mb-4'>
            <tr>
              <td className='text-primary-lightgray w-56'>BOOKING DATE</td>
              <td className='font-medium'>{bookingDate}</td>
            </tr>
            <tr>
              <td className='text-primary-lightgray'>SPACE</td>
              <td className='text-primary-orange font-medium'>
                <Link target='_blank' to={spaceUrl}>{space}</Link>
              </td>
            </tr>
            <tr>
              <td className='text-primary-lightgray font-medium'>NUMBER OF GUESTS</td>
              <td>{numberOfBookings}</td>
            </tr>
            <tr>
              <td className='text-primary-lightgray font-medium'>STATUS</td>
              <td className={`pl-0 p-3 uppercase ${isActive ? 'text-secondary-green' : 'text-action-danger'}`}>{status}</td>
            </tr>
          </table>

          <table className='w-full border-collapse border border-slate-400'>
            <thead className='bg-lightgray'>
              <th className='px-6 py-4 font-medium text-primary-lightgray w-10'>NO.</th>
              <th className='px-6 py-4 font-medium text-base text-primary-lightgray'>GUESTS EMAIL</th>
            </thead>
            {
              list.map((item, index) => (
                <tr key={index} className='border-t'>
                  <td className='px-6 py-4 text-center'>{index + 1}</td>
                  <td className='px-6 py-4'>{item.email} <span className='text-primary-lightgray'>{index === 0 ? `(owner of booking)` : ''}</span></td>
                </tr>
              ))
            }
          </table>
        </div>
      )}
    </Modal>
  )
}

BookingMembersModal.propTypes = {
  fetching: PropTypes.bool,
  bookingDate: PropTypes.string.isRequired,
  space: PropTypes.string.isRequired,
  spaceUrl: PropTypes.string.isRequired,
  list: PropTypes.array.isRequired,
  onClose: PropTypes.func.isRequired,
  numberOfBookings: PropTypes.number.isRequired,
  status: PropTypes.string.isRequired,
}

export default BookingMembersModal
